import LogoMills from "@assets/images/svg/logoMills";
import Col from "react-bootstrap/Col";

function Logo({ welcomeText, myWidth = "36px" }) {
  return (
    <Col
      xs="12"
      className="d-flex align-items-center justify-content-center flex-wrap"
      style={{
        height: "196px",
        marginTop: myWidth,
        flexDirection: "column",
        gap: "14px",
      }}
    >
      <LogoMills />
      {welcomeText ? (
        <h6 className="logo-message">{welcomeText}</h6>
      ) : (
        <div style={{ height: "24px", width: "100%" }}></div>
      )}
    </Col>
  );
}

export default Logo;
